import { render, staticRenderFns } from "./TabTote.vue?vue&type=template&id=e5f6ce58&scoped=true&"
import script from "./TabTote.vue?vue&type=script&lang=js&"
export * from "./TabTote.vue?vue&type=script&lang=js&"
import style0 from "./TabTote.vue?vue&type=style&index=0&id=e5f6ce58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f6ce58",
  null
  
)

export default component.exports